import Button from 'components/button/Button';
import { Modal } from 'react-bootstrap';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface SendOwnerInviteModalFooterProps {
  isLoading: boolean;
  onClose: () => void;
}

const SendOwnerInviteModalFooter = ({
  isLoading,
  onClose,
}: SendOwnerInviteModalFooterProps) => {
  const { t } = useTranslation();
  const { isSubmitting } = useFormState();

  const isDisabled = isSubmitting || isLoading;

  return (
    <Modal.Footer>
      <Button bsStyle="default" onClick={onClose}>
        {t('common.cancel')}
      </Button>
      <Button
        bsStyle="primary"
        data-testid="send-invite-button"
        type="submit"
        disabled={isDisabled}
      >
        {isSubmitting ? t('common.sending') : t('common.send')}
      </Button>
    </Modal.Footer>
  );
};

export default SendOwnerInviteModalFooter;
